<template>
  <multiselect
    v-model="selected"
    :options="options"
    placeholder=""
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    @input="onChange"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    :open-direction="'bottom'"
  />
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['alreadySelected', 'isRequired', 'emptyLabel', 'grupoSelected', 'isDisabled', 'includeAll'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'tipoMetodoPagamento', null);
        return;
      }
      this.$emit('selectChange', 'tipoMetodoPagamento', e);
    },
    setOptions(grupo) {
      let filter = 'ativo=true';
      if (grupo) filter += ` and id_grupo=${grupo.id}`;
      this.isLoading = true;
      this.selected = '';
      this.$atenaList
        .getCommon('tipo_metodo_pagamento', { columns: 'id, nome', filter: filter, order: 'id' })
        .then((res) => {
          let defaultOption = { id: null, nome: this.$i18n.t(this.emptyLabel || 'Todos') };
          this.options = [];
          if (this.includeAll || this.emptyLabel) {
            this.options = [defaultOption];
          }
          this.options = this.options.concat(res.data);
          if (this.alreadySelected) {
            this.selected = this.alreadySelected;
          } else if (this.includeAll || this.emptyLabel) {
            this.selected = defaultOption;
          } else {
            this.selected = res.data[0] || defaultOption;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },

  watch: {
    grupoSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    this.setOptions(this.grupoSelected);
  }
};
</script>

<style lang="scss" scoped></style>
